export default __webpack_public_path__ + "static/media/Stage4.792837bd.jpg";